export default "__VITE_ASSET__db83b948__"